/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <component :is="componentType" ref="compInstance"/>
</template>

<script>
import find from 'lodash/find'
import { isProductUrl } from '@/helpers'
import { urlResolve } from 'theme/helpers'
import { localizedByName } from '@/filters/routers'
import Logger from '@/services/Logger'
import CmsPage from './Cms'
import CategoryPage from './Listing'

export default {
  name: 'FactoryPage',
  computed: {
    componentType () {
      return this.$store.state.cms.currentComponent
    }
  },
  components: {
    CmsPage,
    CategoryPage
  },
  async asyncData (ctx) {
    if (ctx.store.state.ui.redirect) {
      return true
    }
    // reset meta SEO
    let metaRobots = ''
    let metaHrefLang = []
    let jsonLD = []
    let canonical = ''
    let speakable = []

    // speakable default
    if (ctx.store.state.storeConfig.config.seo_markup_speakable &&
        ctx.store.state.storeConfig.config.seo_markup_speakable.json_page) {
      speakable.push(ctx.store.state.storeConfig.config.seo_markup_speakable.json_page)
    }

    // url resolver
    let slug = ctx.route.query.id
    // let categoryId = ctx.state.category.categoryId
    slug = isProductUrl(slug, ctx)
    return urlResolve(slug, ctx).then(res => {
      let promiseArr = []
      switch (res.type) {
        case 'CMS_PAGE':
          ctx.store.commit('ui/setBodyClass', 'cms-page')
          ctx.store.commit('cms/currentComponent', 'CmsPage')
          promiseArr.push(ctx.store.dispatch('cms/getPage', { id: res.id }).then(() => {
            // ctx.store.commit('ui/setHrefLang', metaHrefLang)
            // set robots
            metaRobots = ctx.store.state.cms.meta.meta_robots
            // dati strutturati
            if (ctx.store.state.cms.meta.head_content_page) {
              jsonLD.push(ctx.store.state.cms.meta.head_content_page)
            }
          }))
          break
        case 'CATEGORY':
          // check redirect section
          ctx.store.commit('ui/setBodyClass', 'category')
          if (res.redirectCode !== 0) {
            let newCate = find(ctx.store.state.category.flatted, { id: parseInt(res.id) })
            if (newCate) {
              // eslint-disable-next-line
              throw {
                type: 'redirect',
                url: `/${ctx.store.state.ui.codeLang}/${newCate.url_path + ctx.store.state.storeConfig.config.category_url_suffix}`,
                code: res.redirectCode
              }
            }
          }
          // reset quick view
          ctx.store.commit('listing/setQuickView', null)
          let stringComponent = 'CategoryPage'
          let componentToLoad = CategoryPage
          ctx.store.commit('cms/currentComponent', stringComponent)
          ctx.store.commit('category/setCategoryId', res.id)
          for (let i in componentToLoad.mixins) {
            componentToLoad.mixins[i].asyncData && promiseArr.push(componentToLoad.mixins[i].asyncData(ctx))
          }
          Promise.all(promiseArr).then(() => {
            // set robots
            if (ctx.store.state.category.metaData.meta_robots) {
              metaRobots = ctx.store.state.category.metaData.meta_robots
            }

            if (ctx.store.state.category.metaData.head_content_page) {
              jsonLD = [ctx.store.state.category.metaData.head_content_page]
            }
            // canonical
            if (ctx.store.state.category.metaData.custom_canonical_link) {
              canonical = ctx.store.state.category.metaData.custom_canonical_link
            } else {

            }
            // href lang
            if (ctx.store.state.category.metaData.href_lang_links) {
              metaHrefLang = ctx.store.state.category.metaData.href_lang_links.map(item => ({
                rel: 'alternate',
                hreflang: item.hreflang,
                href: item.href
              }))
            }

            // speakable category
            if (ctx.store.state.storeConfig.config.seo_markup_speakable &&
                ctx.store.state.storeConfig.config.seo_markup_speakable.json_category) {
              speakable = [ctx.store.state.storeConfig.config.seo_markup_speakable.json_category]
            }
          })
          break
        case 'PRODUCT':
          ctx.store.commit('ui/setBodyClass', 'product')
          ctx.store.commit('cms/currentComponent', 'CategoryPage')
          ctx.store.commit('product/setCurrent', {})
          promiseArr.push(ctx.store.dispatch('product/loadByUrlKey', { url_key: slug }).then(product => {
            if (Object.keys(product).length === 0) {
              throw new Error(`product not found: ${slug}`)
            }

            let path = '/'
            let productLink = localizedByName('factoryPage', ctx.store, ctx.router) + path + product.url_key + product.url_suffix

            // set robots
            if (product.meta_robots) {
              metaRobots = product.meta_robots
            }

            if (product && product.head_content_page) {
              jsonLD.push(product.head_content_page)
            }
            if (product && product.seo_markup_product) {
              jsonLD.push(product.seo_markup_product)
            }
            // canonical
            if (product.custom_canonical_link) {
              canonical = product.custom_canonical_link
            } else {
              return productLink
            }
            // href lang
            if (product.href_lang_links) {
              metaHrefLang = product.href_lang_links.map(item => ({
                rel: 'alternate',
                hreflang: item.hreflang,
                href: item.href
              }))
            }
            // speakable product
            if (ctx.store.state.storeConfig.config.seo_markup_speakable &&
                ctx.store.state.storeConfig.config.seo_markup_speakable.json_product) {
              speakable = [ctx.store.state.storeConfig.config.seo_markup_speakable.json_product]
            }
            ctx.store.commit('quickBuy/setToggle', true)
            ctx.store.commit('quickBuy/setCurrentProductUrlKey', productLink)
          }))
          break
        default:
          ctx.redirect({ name: 'page-not-found', params: { lang: ctx.store.state.ui.codeLang } })
      }

      return Promise.all(promiseArr)
        .then(() => {
          // set hreflang
          // ctx.store.commit('ui/setHrefLang', [{ rel: 'alternate', href: 'http://localhost:8080/it_it/the-a-sneaker-brown.html', hreflang: 'it' }])
          ctx.store.commit('ui/setHrefLang', metaHrefLang)
          // set robots
          ctx.store.commit('ui/setRobots', metaRobots)
          // dati strutturati
          ctx.store.commit('ui/setJsonLD', jsonLD.concat(speakable))
          // canonical
          ctx.store.commit('ui/setCanonical', canonical)
        })
        .catch(err => {
          throw err
        })
    })
      .catch(err => {
        if (err && err.type === 'redirect') {
          // redirect in corso
          Logger.debug('REDIRECT to --> ', err.url)
          ctx.redirect(err.url, err.code)
        } else {
          Logger.error(err)
          ctx.redirect({ name: 'page-not-found', params: { lang: ctx.store.state.ui.codeLang } })
        }
      })
  }
}
</script>
